(function () {
  'use strict';

  angular.module('app.component.address-form-contact-info', []);

})();
